import { useContext, useEffect, useState } from 'react';
import type { StoryObject } from '@benzinga/advanced-news-manager';
import { BasicNewsManager } from '@benzinga/basic-news-manager';
import { SessionContext } from '@benzinga/session-context';
import { ECONOMICS_NEWS_OPTIONS, ECONOMICS_NEWS_QUERY, normalizeNewsStories } from './economicsTransform';

const CLIENT_FETCH_FAILED = '[economic-data] economics news rail client fetch failed';

// The page is CDN-cached, so a failed server-side news fetch would otherwise pin an empty rail for every visitor.
export const useEconomicsNews = (initialNews: StoryObject[]) => {
  const session = useContext(SessionContext);
  const [news, setNews] = useState(initialNews);
  const [isLoading, setIsLoading] = useState(initialNews.length === 0);

  useEffect(() => {
    if (initialNews.length > 0) return;
    let cancelled = false;

    const loadNews = async () => {
      try {
        const result = await session
          .getManager(BasicNewsManager)
          .simplyQueryNews(ECONOMICS_NEWS_QUERY, ECONOMICS_NEWS_OPTIONS);
        if (result.err) {
          console.error(CLIENT_FETCH_FAILED, result.err);
        }
        if (!cancelled) {
          setNews(normalizeNewsStories(result.ok ?? []));
        }
      } catch (error) {
        console.error(CLIENT_FETCH_FAILED, error);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    void loadNews();
    return () => {
      cancelled = true;
    };
  }, [initialNews, session]);

  return { isLoading, news };
};
